import { Page } from "@/models/page-models/Page";

export const MaterialStock: Page = {
  "path": "material-stock",
  "name": "Material Stock",
  "props": {
    "data": {
      "title": "Material Stock",
      "printable": "FALSE",
      "url": "material-stock",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "RM",
              "bracketValueFormula": "{{fetchedData.rm.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "formData.rmForm.q",
                      "label": "Search RMs",
                      "disabled": "FALSE"
                    },
                    {
                      "type": "button",
                      "label": "Search",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultRmPageNo",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultPageNo",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData.rmForm",
                            "arg3Key": "append",
                            "arg3Value": "TRUE",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object"
                          },
                          "name": "copyDefaultRmPageNo"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "getRmGoods",
                            "type": "fnGetData",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v2/goods/search",
                            "arg2Key": "postData",
                            "arg2Value": "formData.rmForm",
                            "arg3Key": "storeInVar",
                            "arg3Value": "fetchedData.rm"
                          },
                          "name": "getRmGoods"
                        }
                      ],
                      "disabled": "FALSE",
                      "color": "secondary"
                    }
                  ]
                },
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "RMs",
                      "disabled": "FALSE",
                      "items": "fetchedData.rm.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "RM#"
                        },
                        {
                          "value": "__item.type",
                          "text": "RM Type"
                        },
                        {
                          "value": "__item.details",
                          "text": "Good Details",
                          "formula": "fn(HELPER_FN,goodsName,{{__item}})"
                        },
                        {
                          "value": "__item.density",
                          "text": "Density",
                          "type": "formula",
                          "formula": "{{__item.density}} {{__item.densityUnit}}"
                        },
                        {
                          "value": "__item.location.Warehouse.totalQuantity",
                          "text": "Warehouse Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.location.Warehouse.totalQuantity}},{{__item}})}},{{__item.location.Warehouse.totalQuantity}})",
                          "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),SQM,KG)"
                        },
                        {
                          "value": "__item.location.Factory.totalQuantity",
                          "text": "Factory Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.location.Factory.totalQuantity}},{{__item}})}},{{__item.location.Factory.totalQuantity}})",
                          "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),SQM,KG)"
                        }
                      ],
                      "tableType": "static",
                      "pagination": {
                        "pageVariable": "formData.rmForm.page",
                        "serverItemsLengthVariable": "fetchedData.rm.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "pageFunction": {
                              "name": "getRmGoods",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v2/goods/search",
                              "arg2Key": "postData",
                              "arg2Value": "formData.rmForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.rm"
                            },
                            "name": "getRmGoods"
                          }
                        ]
                      }
                    }
                  ]
                }
              ],
              "showIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
            },
            {
              "tabName": "FG",
              "bracketValueFormula": "{{fetchedData.fg.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "formData.fgForm.q",
                      "label": "Search FGs",
                      "disabled": "FALSE"
                    },
                    {
                      "type": "button",
                      "label": "Search",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultFgPageNo",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultPageNo",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData.fgForm",
                            "arg3Key": "append",
                            "arg3Value": "TRUE",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object"
                          },
                          "name": "copyDefaultFgPageNo"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "getFgGoods",
                            "type": "fnGetData",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v2/goods/search",
                            "arg2Key": "postData",
                            "arg2Value": "formData.fgForm",
                            "arg3Key": "storeInVar",
                            "arg3Value": "fetchedData.fg"
                          },
                          "name": "getFgGoods"
                        }
                      ],
                      "disabled": "FALSE",
                      "color": "secondary"
                    },
                    {
                      "type": "button",
                      "label": "Add FG",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "redirectToGoodsEditor",
                            "type": "fnRedirect",
                            "arg1Key": "redirectUrl",
                            "arg1Value": "/goodsEditor/"
                          },
                          "name": "redirectToGoodsEditor"
                        }
                      ],
                      "disabled": "FALSE",
                      "showIf": "fn(MATCH_ROLE,Customer Service | Manager)",
                      "color": "primary"
                    }
                  ]
                },
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "dropdown",
                      "variable": "formData.fgForm.customer",
                      "label": "Filter By Customer",
                      "onChange": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultFgPageNo",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultPageNo",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData.fgForm",
                            "arg3Key": "append",
                            "arg3Value": "TRUE",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object"
                          },
                          "name": "copyDefaultFgPageNo"
                        },
                        {
                          "executionOrder": 3,
                          "pageFunction": {
                            "name": "getFgGoods",
                            "type": "fnGetData",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v2/goods/search",
                            "arg2Key": "postData",
                            "arg2Value": "formData.fgForm",
                            "arg3Key": "storeInVar",
                            "arg3Value": "fetchedData.fg"
                          },
                          "name": "getFgGoods"
                        },
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyProductsForm",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultProductForm",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.fgProductForm"
                          },
                          "name": "copyProductsForm"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "pushCustomerIdToProductForm",
                            "type": "fnPushToArray",
                            "arg1Key": "sourceVariable",
                            "arg1Value": "formData.fgForm.customer",
                            "arg2Key": "destinationVariable",
                            "arg2Value": "fetchedData.fgProductForm.q.customer"
                          },
                          "name": "pushCustomerIdToProductForm"
                        },
                        {
                          "executionOrder": 3,
                          "pageFunction": {
                            "name": "getProducts",
                            "type": "fnGetData",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/product/search",
                            "arg2Key": "postData",
                            "arg2Value": "fetchedData.fgProductForm",
                            "arg3Key": "storeInVar",
                            "arg3Value": "fetchedData.products"
                          },
                          "name": "getProducts"
                        }
                      ],
                      "disabled": "FALSE",
                      "items": "fetchedData.customers.data",
                      "itemText": "name",
                      "itemValue": "_id",
                      "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                    },
                    {
                      "type": "dropdown",
                      "variable": "formData.fgForm.product",
                      "label": "Filter By Product",
                      "disabled": "FALSE",
                      "onChange": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultFgPageNo",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultPageNo",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData.fgForm",
                            "arg3Key": "append",
                            "arg3Value": "TRUE",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object"
                          },
                          "name": "copyDefaultFgPageNo"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "getFgGoods",
                            "type": "fnGetData",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v2/goods/search",
                            "arg2Key": "postData",
                            "arg2Value": "formData.fgForm",
                            "arg3Key": "storeInVar",
                            "arg3Value": "fetchedData.fg"
                          },
                          "name": "getFgGoods"
                        }
                      ],
                      "items": "fetchedData.products.data.docs",
                      "itemText": "alias",
                      "itemValue": "_id",
                      "formula": "fn(CONCAT,{{__item._id}}, ,fn(HELPER_FN,productAlias,{{__item}}))"
                    }
                  ]
                },
                {
                  "name": "3",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "FGs",
                      "disabled": "FALSE",
                      "items": "fetchedData.fg.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "FG#"
                        },
                        {
                          "value": "__item.factoryTicket.order._id",
                          "text": "Order #",
                          "type": "url",
                          "url": "/order/{{__item.factoryTicket.order._id}}"
                        },
                        {
                          "value": "__item.factoryTicket.order.product._id",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.factoryTicket.order.product}})"
                        },
                        {
                          "value": "__item.factoryTicket.order.customer._id",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.factoryTicket.order.customer}})"
                        },
                        {
                          "value": "__item.location.Warehouse.totalQuantity",
                          "text": "Warehouse Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.factoryTicket.order}},{{__item}},{{__item.location.Warehouse.totalQuantity}})",
                          "filterParam": "{{__item.factoryTicket.order.product.unit.unit2}}"
                        },
                        {
                          "value": "__item.location.Factory.totalQuantity",
                          "text": "Factory Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.factoryTicket.order}},{{__item}},{{__item.location.Factory.totalQuantity}})",
                          "filterParam": "{{__item.factoryTicket.order.product.unit.unit2}}"
                        }
                      ],
                      "tableType": "static",
                      "pagination": {
                        "pageVariable": "formData.fgForm.page",
                        "serverItemsLengthVariable": "fetchedData.fg.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "pageFunction": {
                              "name": "getFgGoods",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v2/goods/search",
                              "arg2Key": "postData",
                              "arg2Value": "formData.fgForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.fg"
                            },
                            "name": "getFgGoods"
                          }
                        ]
                      }
                    }
                  ],
                  "showIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Manager))"
                },
                {
                  "name": "3",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "FGs (1)",
                      "disabled": "FALSE",
                      "items": "fetchedData.fg.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "FG#"
                        },
                        {
                          "value": "__item.factoryTicket.order._id",
                          "text": "Order #",
                          "type": "url",
                          "url": "/order/{{__item.factoryTicket.order._id}}"
                        },
                        {
                          "value": "__item.factoryTicket.order.product._id",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.factoryTicket.order.product}})"
                        },
                        {
                          "value": "__item.factoryTicket.order.customer._id",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.factoryTicket.order.customer}})"
                        },
                        {
                          "value": "__item.location.Warehouse.totalQuantity",
                          "text": "Warehouse Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.factoryTicket.order}},{{__item}},{{__item.location.Warehouse.totalQuantity}})",
                          "filterParam": "{{__item.factoryTicket.order.product.unit.unit2}}"
                        },
                        {
                          "value": "__item.location.Factory.totalQuantity",
                          "text": "Factory Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.factoryTicket.order}},{{__item}},{{__item.location.Factory.totalQuantity}})",
                          "filterParam": "{{__item.factoryTicket.order.product.unit.unit2}}"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Request FG Goods",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "copyFGId",
                                "type": "fnCopyData",
                                "arg1Key": "sourceKey",
                                "arg1Value": "__item._id",
                                "arg2Key": "destinationKey",
                                "arg2Value": "fetchedData.fgId"
                              },
                              "name": "copyFGId"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "openFGRequestPopup",
                                "type": "fnOpenPopup",
                                "arg1Key": "popupName",
                                "arg1Value": "Request FG quantity"
                              },
                              "name": "openFGRequestPopup"
                            }
                          ]
                        },
                        {
                          "label": "Remove FG Stock",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markAsInactiveFg",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/goods/{{__item._id}}/mark-inactive",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH"
                              },
                              "name": "markAsInactiveFg"
                            },
                            {
                              "executionOrder": 2,
                              "executeOnce": true,
                              "pageFunction": {
                                "name": "getFgGoods",
                                "type": "fnGetData",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v2/goods/search",
                                "arg2Key": "postData",
                                "arg2Value": "formData.fgForm",
                                "arg3Key": "storeInVar",
                                "arg3Value": "fetchedData.fg"
                              },
                              "name": "getFgGoods"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "formData.fgForm.page",
                        "serverItemsLengthVariable": "fetchedData.fg.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "pageFunction": {
                              "name": "getFgGoods",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v2/goods/search",
                              "arg2Key": "postData",
                              "arg2Value": "formData.fgForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.fg"
                            },
                            "name": "getFgGoods"
                          }
                        ]
                      }
                    }
                  ],
                  "showIf": "fn(MATCH_ROLE,Customer Service | Manager)"
                }
              ],
              "showIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Inbound Warehouse))"
            },
            {
              "tabName": "WIP",
              "bracketValueFormula": "{{fetchedData.wip.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "input",
                      "variable": "formData.wipForm.q",
                      "label": "Search WIPs",
                      "disabled": "FALSE"
                    },
                    {
                      "type": "button",
                      "label": "Search",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultWipPageNo",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultPageNo",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData.wipForm",
                            "arg3Key": "append",
                            "arg3Value": "TRUE",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object"
                          },
                          "name": "copyDefaultWipPageNo"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "getWipGoods",
                            "type": "fnGetData",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v2/goods/search",
                            "arg2Key": "postData",
                            "arg2Value": "formData.wipForm",
                            "arg3Key": "storeInVar",
                            "arg3Value": "fetchedData.wip"
                          },
                          "name": "getWipGoods"
                        }
                      ],
                      "disabled": "FALSE",
                      "color": "secondary"
                    }
                  ]
                },
                {
                  "name": "2a",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "WIPs",
                      "disabled": "FALSE",
                      "items": "fetchedData.wip.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "WIP#"
                        },
                        {
                          "value": "__item.details",
                          "text": "Good Details",
                          "formula": "fn(HELPER_FN,goodsName,{{__item}})"
                        },
                        {
                          "value": "__item.density",
                          "text": "Density",
                          "type": "formula",
                          "formula": "{{__item.density}} {{__item.densityUnit}}"
                        },
                        {
                          "value": "__item.location.Warehouse.totalQuantity",
                          "text": "Warehouse Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.location.Warehouse.totalQuantity}},{{__item}})}},{{__item.location.Warehouse.totalQuantity}})",
                          "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),SQM,KG)"
                        },
                        {
                          "value": "__item.location.Factory.totalQuantity",
                          "text": "Factory Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.location.Factory.totalQuantity}},{{__item}})}},{{__item.location.Factory.totalQuantity}})",
                          "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),SQM,KG)"
                        }
                      ],
                      "tableType": "static",
                      "pagination": {
                        "pageVariable": "formData.wipForm.page",
                        "serverItemsLengthVariable": "fetchedData.wip.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "pageFunction": {
                              "name": "getWipGoods",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v2/goods/search",
                              "arg2Key": "postData",
                              "arg2Value": "formData.wipForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.wip"
                            },
                            "name": "getWipGoods"
                          }
                        ]
                      }
                    }
                  ],
                  "showIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Manager))"
                },
                {
                  "name": "2b",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "WIPs",
                      "disabled": "FALSE",
                      "items": "fetchedData.wip.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "WIP#"
                        },
                        {
                          "value": "__item.details",
                          "text": "Good Details",
                          "formula": "fn(HELPER_FN,goodsName,{{__item}})"
                        },
                        {
                          "value": "__item.density",
                          "text": "Density",
                          "type": "formula",
                          "formula": "{{__item.density}} {{__item.densityUnit}}"
                        },
                        {
                          "value": "__item.location.Warehouse.totalQuantity",
                          "text": "Warehouse Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.location.Warehouse.totalQuantity}},{{__item}})}},{{__item.location.Warehouse.totalQuantity}})",
                          "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),SQM,KG)"
                        },
                        {
                          "value": "__item.location.Factory.totalQuantity",
                          "text": "Factory Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.location.Factory.totalQuantity}},{{__item}})}},{{__item.location.Factory.totalQuantity}})",
                          "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),SQM,KG)"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Remove WIP Stock",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markAsInactiveWip",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/goods/{{__item._id}}/mark-inactive",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH"
                              },
                              "name": "markAsInactiveWip"
                            },
                            {
                              "executionOrder": 2,
                              "executeOnce": true,
                              "pageFunction": {
                                "name": "getWipGoods",
                                "type": "fnGetData",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v2/goods/search",
                                "arg2Key": "postData",
                                "arg2Value": "formData.wipForm",
                                "arg3Key": "storeInVar",
                                "arg3Value": "fetchedData.wip"
                              },
                              "name": "getWipGoods"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "formData.wipForm.page",
                        "serverItemsLengthVariable": "fetchedData.wip.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "pageFunction": {
                              "name": "getWipGoods",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v2/goods/search",
                              "arg2Key": "postData",
                              "arg2Value": "formData.wipForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.wip"
                            },
                            "name": "getWipGoods"
                          }
                        ]
                      }
                    }
                  ],
                  "showIf": "fn(MATCH_ROLE,Customer Service | Manager)"
                }
              ],
              "showIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Request FG quantity",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.quantity",
                  "label": "Quantity",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "sendFgRequest",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/goods/request-fg/{{fetchedData.fgId}}",
                    "arg2Key": "postData",
                    "arg2Value": "formData"
                  },
                  "name": "sendFgRequest"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeFGRequestPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Request FG quantity"
                  },
                  "name": "closeFGRequestPopup"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultRmQuery",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultQuery",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.rmForm"
        },
        "name": "copyDefaulRmQuery",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultRmPageNo",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPageNo",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.rmForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultRmPageNo",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyRmStatus",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getRmStatus",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.rmForm.filters"
        },
        "name": "copyRmStatus",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getRmGoods",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/goods/search",
          "arg2Key": "postData",
          "arg2Value": "formData.rmForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.rm"
        },
        "name": "getRmGoods",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultFgQuery",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultQuery",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.fgForm"
        },
        "name": "copyDefaulFgQuery",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Inbound Warehouse))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultFgPageNo",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPageNo",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.fgForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultFgPageNo",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Inbound Warehouse))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyFgStatus",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getFgStatus",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.fgForm.filters"
        },
        "name": "copyFgStatus",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Inbound Warehouse))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getFgGoods",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/goods/search",
          "arg2Key": "postData",
          "arg2Value": "formData.fgForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.fg"
        },
        "name": "getFgGoods",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Inbound Warehouse))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultWipQuery",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultQuery",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.wipForm"
        },
        "name": "copyDefaultWipQuery",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultWipPageNo",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPageNo",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.wipForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultWipPageNo",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyWipStatus",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getWipStatus",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.wipForm.filters"
        },
        "name": "copyWipStatus",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getWipGoods",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/goods/search",
          "arg2Key": "postData",
          "arg2Value": "formData.wipForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.wip"
        },
        "name": "getWipGoods",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE))"
      }
    ],
    "functions": [
      {
        "name": "getDefaultQuery",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": ""
        },
        "useFormula": true
      },
      {
        "name": "getDefaultPageNo",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1"
        },
        "useFormula": true
      },
      {
        "name": "getRmStatus",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "status": "RM"
        },
        "useFormula": true
      },
      {
        "name": "getFgStatus",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "status": "FG"
        },
        "useFormula": true
      },
      {
        "name": "getWipStatus",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "status": "WIP"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultProductForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": {},
          "page": 1
        },
        "staticObject": true,
      }
    ]
  },
  "forRole": "CUSTOMER_SERVICE_MANAGER,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE",
  "visible": true,
  "routerPriority": 50
}